import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LuggageAmountValues } from "src/app/models/LuggageAmountValues.model";
import { LuggageAmounteServiceClass } from "src/app/models/LuggageAmounteServiceClass.model";
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { LuggageAmountServiceClassMatrixData } from './LuggageAmountServiceClassMatrixData.model';
import { ServiceClass } from 'src/app/models/serviceClass.model';
import { LuggageType } from 'src/app/models/luggageType.model';
import { CloneService } from 'src/app/services/clone.service';

@Component({
  selector: 'app-luggage-amount-window',
  templateUrl: './luggage-amount-window.component.html',
  styleUrls: ['./luggage-amount-window.component.scss']
})
export class LuggageAmountWindowComponent implements OnInit {
  button1: string = 'Cancel';
  button2: string = 'Okay';
  matrix: LuggageAmountServiceClassMatrixData[] = [];
  gridData: GridData = new GridData();
  isEditable;
  constructor(
    public dialogRef: MatDialogRef<LuggageAmountWindowComponent>,private cloneService:CloneService,
    @Inject(MAT_DIALOG_DATA) public data: { data: LuggageAmounteServiceClass[], rowHeaders: ServiceClass[], colHeaders: LuggageType[], isEditable:boolean }) {
      dialogRef.disableClose = true;
      this.gridData = this.ConvertData();
      this.isEditable = this.data.isEditable;
  }

  ngOnInit() { }

  ConvertData(): GridData {
    this.matrix = this.fillWithZeros(this.matrix);

    for (let j = 0; j < this.matrix.length; j++) {
      const element = this.matrix[j];
      for (let i = 0; i < this.data.data.length; i++) {
        const sClass = this.data.data[i];
        if(sClass.luggageValues){
          for (let index = 0; index < sClass.luggageValues.length; index++) {
            const lugagge = sClass.luggageValues[index];
            if (element.luggageTypeId === lugagge.luggageTypeId + 1 && element.serviceClassId === sClass.serviceClassId + 1) {
              element.value = lugagge.value;
              // element.value = Math.round(lugagge.value * 100);
              element.luggageAmountId = sClass.luggageAmountId;
            }
          }
        }        
      }
    }
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.data.rowHeaders.length; i++) {
      const headerEntry = this.data.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.data.colHeaders.length; i++) {
      const headerEntry = this.data.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix;
    grid.colProp = 'luggageTypeId';
    grid.rowProp = 'serviceClassId';
    grid.switchColWithRow = false;
    return grid;
  }

  fillWithZeros(matrix: LuggageAmountServiceClassMatrixData[]): LuggageAmountServiceClassMatrixData[] {

    if(matrix == null){
      matrix = new Array<LuggageAmountServiceClassMatrixData>();
    }

    for (let i = 0; i < this.data.rowHeaders.length; i++) {
      const headerEntryrow = this.data.rowHeaders[i];
      for (let j = 0; j < this.data.colHeaders.length; j++) {
        const headerEntrycol = this.data.colHeaders[j];
        let mO = new LuggageAmountServiceClassMatrixData();
        mO.luggageTypeId = headerEntrycol.id + 1;
        mO.serviceClassId = headerEntryrow.id + 1;
        mO.value = 0;
        mO.luggageAmountId = -1;
        matrix.push(mO);
      }
    }
    return matrix;
  }

  cancel() {
    this.dialogRef.close({ save: false, data: null });
  }

  save() {
    let clonedGridMatrix = this.cloneService.deepClone(this.gridData.matrix);

    for (let i = 0; i < clonedGridMatrix.length; i++) {
      const element = clonedGridMatrix[i] as LuggageAmountServiceClassMatrixData;
      element.luggageTypeId -= 1;
      element.serviceClassId -= 1;
    }

    let tempLuggageAmounteServiceClasses: LuggageAmounteServiceClass[] = []

    for (let i = 0; i < this.data.rowHeaders.length; i++) {
      const headerEntry = this.data.rowHeaders[i];
      let temp: LuggageAmountServiceClassMatrixData[] = [];
      for (let j = 0; j < clonedGridMatrix.length; j++) {
        const element = clonedGridMatrix[j] as LuggageAmountServiceClassMatrixData;

        if (headerEntry.id === element.serviceClassId) {
          temp.push(element);
        }
      }
      tempLuggageAmounteServiceClasses.push(this.ConvertDataBack(temp));
    }

    this.dialogRef.close({ save: true, data: tempLuggageAmounteServiceClasses });
  }
  
  ConvertDataBack(input: LuggageAmountServiceClassMatrixData[]): LuggageAmounteServiceClass {
    let output: LuggageAmounteServiceClass = new LuggageAmounteServiceClass();
    output.internalDescription = "";
    output.luggageAmountId = input[0].luggageAmountId;
    output.serviceClassId = input[0].serviceClassId;

    let values: LuggageAmountValues[] = [];
    for (let i = 0; i < input.length; i++) {
      const element = input[i];
      let value: LuggageAmountValues = new LuggageAmountValues();
      value.luggageTypeId = element.luggageTypeId;
      value.value = element.value;
      // value.value = element.value / 100;
      values.push(value);
    }
    output.luggageValues = values;
    return output;
  }
}
